import debounce from 'lodash.debounce';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

import TokenStore from '../stores/TokenStore';
import SyncAPI from '../util/SyncAPI';

const SyncActions = {
  loadAllSyncs(organizationId) {
    const api = new SyncAPI(TokenStore.getToken()).syncs;
    api.status(organizationId, 25000).then((syncs) => {
      AppDispatcher.dispatch({
        actionType: Constants.RECEIVE_RAW_SYNCS,
        organizationId,
        rawSyncs: syncs,
      });
    }).catch((e) => {
      console.warn('Unable to load syncs.', e);
    });
  },

  // TODO: This is a hack until the api is fixed
  pollSyncs(organizationId) {
    SyncActions.loadAllSyncs(organizationId);
    const intervalChecker = setInterval(() => { SyncActions.debouncedLoadAllSyncs(organizationId); }, 10000);
    return () => { clearInterval(intervalChecker); };
  },

};

SyncActions.debouncedLoadAllSyncs = debounce(SyncActions.loadAllSyncs, 1000);

export default SyncActions;
